import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import '../../styles/classes/index.scss';
export const Provider = ({ children }) => {
    return _jsx(_Fragment, { children: children });
};
